import { getLayout as getHomeLayout } from '~/components/Layouts/HomeLayout/HomeLayout';
import { PrivateRecentlyDeleted as RecentlyDeletedV2 } from '~/components/v2/components/recently-deleted/PrivateRecentlyDeleted';
import { PrivatePageLayout } from '~/components/v2/layouts/PrivatePageLayout';

export default function RecentlyDeletedPage() {
  return (
    <PrivatePageLayout>
      <RecentlyDeletedV2 />
    </PrivatePageLayout>
  );
}

RecentlyDeletedPage.getLayout = getHomeLayout;
